var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSound = function SvgSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.25,
    d: "M14.385 15.92a.875.875 0 0 0 1.19.337 4.87 4.87 0 0 0 2.5-4.257 4.87 4.87 0 0 0-2.467-4.24.875.875 0 0 0-.866 1.522A3.12 3.12 0 0 1 16.324 12c0 1.145-.62 2.18-1.602 2.73a.875.875 0 0 0-.337 1.19Zm1.29 3.673a.875.875 0 0 0 1.168.409A8.88 8.88 0 0 0 21.875 12a8.87 8.87 0 0 0-4.95-7.962.875.875 0 0 0-.774 1.57A7.12 7.12 0 0 1 20.125 12a7.13 7.13 0 0 1-4.04 6.425.875.875 0 0 0-.41 1.168Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "m7.707 15.293-.214-.214-.297-.06-3.392-.678a1 1 0 0 1-.804-.98V10.64a1 1 0 0 1 .804-.98l3.392-.68.297-.059.214-.214L11 5.414v13.172z"
  })));
};
export default SvgSound;